import styles from './text-field.module.scss';
import { cloneElement, ReactNode } from 'react';
import MaterialTextField from '@mui/material/TextField';
import FormControl from '../form-control/form-control';
import MaterialAutocomplete from '@mui/material/Autocomplete';
import MaterialFormHelperText from '@mui/material/FormHelperText';
import MaterialFilledInput from '@mui/material/FilledInput';
import { FixedSizeList, ListChildComponentProps } from 'react-window';

/* eslint-disable-next-line */
export interface TextFieldProps {
  // autoComplete?: string,
  // autoFocus?: boolean,
  // classes?: object,
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  defaultValue?: any,
  disabled?: boolean,
  error?: boolean,
  // FormHelperTextProps?: object,
  fullWidth?: boolean,
  helperText?: any,
  // id?: string,
  // InputLabelProps?: object,
  // inputProps?: object,
  InputProps?: object,
  inputRef?: any,
  label?: ReactNode,
  margin?: 'dense' | 'none' | 'normal',
  maxRows?: number | string,
  minRows?: number | string,
  multiline?: boolean,
  name?: string,
  onBlur?: (event: any) => void,
  onChange?: (event: any) => void,
  onKeyDown?: (event: any) => void,
  placeholder?: string,
  required?: boolean,
  rows?: number | string,
  // select?: boolean,
  // SelectProps?: object,
  size?: 'medium' | 'small',
  sx?: any,
  type?: string,
  value?: any,
  variant?: 'filled' | 'outlined' | 'standard',
  hiddenLabel?: boolean,
  className?: string,
  onFocus?: (event: any) => void,
  ['data-testid']?: string
}

export interface AutocompleteProps {
  options: any,
  renderInput: any,
  multiple?: boolean,
  // autoComplete?: boolean,
  // autoHighlight?: boolean,
  // autoSelect?: boolean,
  // blurOnSelect?: 'mouse' | 'touch' | boolean,
  // ChipProps?: object,
  // classes?: object,
  // clearIcon?: ReactNode,
  // clearOnBlur?: boolean,
  // clearOnEscape?: boolean,
  clearText?: string,
  closeText?: string,
  // componentsProps?: object,
  // defaultValue?: any,
  // disableClearable?: boolean,
  // disableCloseOnSelect?: boolean,
  // disabled?: boolean,
  // disabledItemsFocusable?: boolean,
  // disableListWrap?: boolean,
  disablePortal?: boolean,
  filterOptions?: (options: Array<any>, state: object) => Array<any>,
  // filterSelectedOptions?: boolean,
  // forcePopupIcon?: 'auto' | boolean,
  freeSolo?: boolean,
  fullWidth?: boolean,
  // getLimitTagsText?: (more: number) => ReactNode,
  // getOptionDisabled?: (option: any) => boolean,
  getOptionLabel?: (option: any) => string,
  // groupBy?: (options: any) => string,
  // handleHomeEndKeys?: boolean,
  id?: string,
  // includeInputInList?: boolean,
  // inputValue?: string,
  isOptionEqualToValue?: (option: any, value: any) => boolean,
  limitTags?: number,
  ListboxComponent?: any,
  // ListboxProps?: object,
  // loading?: boolean,
  // loadingText?: ReactNode,
  // multiple?: boolean,
  // noOptionsText?: ReactNode,
  onChange?: (event: any, value: any | Array<any>) => void,
  //   reason: string, details?: string) => void,
  onClose?: (event: React.SyntheticEvent, reason: string) => void,
  // onHighlightChange?: (event: React.SyntheticEvent,
  //   option: any, reason: string) => void,
  onInputChange?: (event: React.SyntheticEvent, value: string, reason: string) => void,
  // onOpen?: (event: React.SyntheticEvent) => void,
  // open?: boolean,
  // openOnFocus?: boolean,
  openText?: string,
  // PaperComponent?: ElementType,
  // PopperComponent?: ElementType,
  // popupIcon?: ReactNode,
  // renderGroup?: (params: AutocompleteRenderGroupParams) => ReactNode,
  renderOption?: any,
  //   option: any, state: object) => ReactNode,
  renderTags?: (value: Array<any>, getTagProps: any) => ReactNode
  // selectOnFocus?: boolean,
  size?: 'small' | 'medium',
  sx?: any,
  value?: any,
  className?: string
}

export interface FormHelperTextProps {
  children?: any,
  // classes?: object,
  // component?: any,
  // disabled?: boolean,
  error?: boolean,
  // filled?: boolean,
  // focused?: boolean,
  // margin?: 'dense',
  required?: boolean,
  sx?: any,
  // variant?: 'filled' | 'outlined' | 'standard'
}

export interface FilledInputProps {
  autoComplete?: string,
  // autoFocus?: boolean,
  // classes?: object,
  color?: 'primary' | 'secondary',
  // components?: any,
  // componentsProps?: any,
  // defaultValue?: any,
  disabled?: boolean,
  // disableUnderline?: boolean,
  // endAdornment?: ReactNode,
  error?: boolean,
  fullWidth?: boolean,
  hiddenLabel?: boolean,
  // id?: string,
  // inputComponent?: any,
  // inputProps?: object,
  inputRef?: any,
  margin?: 'dense' | 'none',
  maxRows?: number | string,
  minRows?: number | string,
  multiline?: boolean,
  name?: string,
  onChange?: (event: any) => void,
  onBlur?: () => void,
  placeholder?: string,
  readOnly?: boolean,
  required?: boolean,
  rows?: number | string,
  // startAdornment?: ReactNode,
  sx?: any,
  type?: string,
  value?: any
}

export function TextField(props: TextFieldProps) {
  const handleKeyDown = (event: any) => { //Default keydown handler: blur on Enter
    if (event.key === 'Enter') {
      event.target.blur();
    }
  };

  return (
    <FormControl
      fullWidth={props.fullWidth}
      label={props.label}>
      <MaterialTextField
        {...props}
        label={null}
        hiddenLabel={props.hiddenLabel || true}
        onChange={props.onChange}
        onBlur={props.onBlur}
        color={props.color}
        size={props.size || 'small'}
        variant={props.variant || 'filled'}
        value={props.value}
        defaultValue={props.defaultValue}
        onKeyDown={props.onKeyDown || handleKeyDown}
        type={props.type || 'text'}
        disabled={props.disabled}
        sx={props.sx}
        placeholder={props.placeholder}
        multiline={props.multiline}
        InputProps={props.InputProps}
        className={props.className}
        helperText={props.helperText}
        error={props.error}
        margin={props.margin}
        inputRef={props.inputRef}
        rows={props.rows}
        maxRows={props.maxRows}
        minRows={props.minRows}
        name={props.name}
        onFocus={props.onFocus}
        required={props.required}
        data-testid={props['data-testid']}>
      </MaterialTextField>
    </FormControl>
  );
}

export function Autocomplete(props: AutocompleteProps) {
  return (
    <MaterialAutocomplete
      // disablePortal
      id={props.id}
      options={props.options}
      sx={props.sx}
      renderInput={props.renderInput}
      renderOption={props.renderOption}
      filterOptions={props.filterOptions}
      onChange={props.onChange}
      onInputChange={props.onInputChange}
      getOptionLabel={props.getOptionLabel}
      ListboxComponent={props.ListboxComponent}
      isOptionEqualToValue={props.isOptionEqualToValue}
      noOptionsText={'Ingen treff'}
      clearText={props.clearText}
      openText={props.openText}
      closeText={props.closeText}
      className={props.className}
      size={props.size}
      onClose={props.onClose}
      multiple={props.multiple}
      freeSolo={props.freeSolo}
      value={props.value}
      limitTags={props.limitTags}
      fullWidth={props.fullWidth}
      renderTags={props.renderTags}
    />
  );
}

export function FormHelperText(props: FormHelperTextProps) {
  return (
    <MaterialFormHelperText
      error={props.error}
      required={props.required}>
      {props.children}
    </ MaterialFormHelperText>
  );
}

export function FilledInput(props: FilledInputProps) {
  return (
    <MaterialFilledInput
      autoComplete={props.autoComplete}
      color={props.color}
      disabled={props.disabled}
      error={props.error}
      fullWidth={props.fullWidth}
      hiddenLabel={props.hiddenLabel}
      inputRef={props.inputRef}
      margin={props.margin}
      maxRows={props.maxRows}
      minRows={props.minRows}
      multiline={props.multiline}
      name={props.name}
      onChange={props.onChange}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      required={props.required}
      rows={props.rows}
      sx={props.sx}
      type={props.type}
      onBlur={props.onBlur}
      value={props.value}
    />
  );
}

export function MultiLineTextField(props: TextFieldProps) {
  return (
    <TextField
      {...props}
      multiline
      onKeyDown={() => { }}
    />
  );
}

export function VirtualizedListbox(props: any) {
  const { children, ...other } = props;
  const itemCount = Array.isArray(children) ? children.length : 0;
  const itemSize = 36;

  const renderRow = ({ index, style }: ListChildComponentProps) => {
    return cloneElement(children[index], {
      style: { ...style, top: style.top },
    });
  };

  return (
    <div {...other}>
      <FixedSizeList
        height={Math.min(8, itemCount) * itemSize}
        width="100%"
        itemSize={itemSize}
        itemCount={itemCount}
        overscanCount={5}>
        {renderRow}
      </FixedSizeList>
    </div>
  );
}

export default TextField;